import Music1 from 'images/thumbs/music/music1.png';
import Music2 from 'images/thumbs/music/music2.png';
import Music3 from 'images/thumbs/music/music3.png';
import Music4 from 'images/thumbs/music/music4.png';
import Music5 from 'images/thumbs/music/music5.png';
import Music6 from 'images/thumbs/music/music6.png';
import Music7 from 'images/thumbs/music/music7.png';
import Music8 from 'images/thumbs/music/music8.png';
import Music9 from 'images/thumbs/music/music9.png';
import Music10 from 'images/thumbs/music/music10.png';


export const SONGS = [
    { title: 'Dolar', slug: 'dolar', thumb: { path: Music1 }, project: 5 },
    { title: 'Mito Solar', slug: 'mito-solar', thumb: { path: Music3 }, project: 5 },
    { title: 'Reggae Dó', slug: 'reggae-do', thumb: { path: Music4 }, project: 5 },
    { title: 'Mais vale nunca', slug: 'mais-vale-nunca', thumb: { path: Music2 }, project: 5 },
    { title: 'Maria Joana', slug: 'maria-joana', thumb: { path: Music5 }, project: 5 },
    { title: 'Macau', slug: 'macau', thumb: { path: Music6 }, project: 5 },
    { title: 'Dona Laura', slug: 'dona-laura', thumb: { path: Music7 }, project: 5 },
    { title: 'Celebration', slug: 'celebration', thumb: { path: Music8 }, project: 5 },
    { title: 'Lembra-te de mim', slug: 'lembra-te-de-mim', thumb: { path: Music9 }, project: 5 },
    { title: 'Always on my mind', slug: 'always-on-my-mind', thumb: { path: Music10 }, project: 5 },

    { title: 'Até ao Fim', slug: 'ate-ao-fim', thumb: { path: Music1 }, project: 6 },
    { title: 'Gosto de Ti', slug: 'gosto-de-ti', thumb: { path: Music2 }, project: 6 },
    { title: 'Tata', slug: 'tata', thumb: { path: Music3 }, project: 6 },
    { title: 'Forever Young', slug: 'forever-young', thumb: { path: Music7 }, project: 6 },
    { title: 'The Door', slug: 'the-door', thumb: { path: Music4 }, project: 6 },
    { title: 'APT', slug: 'apt', thumb: { path: Music5 }, project: 6 },
    { title: 'Si Antes de Hubiera Conocido', slug: 'si-antes', thumb: { path: Music6 }, project: 6 },
    { title: 'Birds of a feather', slug: 'birds', thumb: { path: Music8 }, project: 6 },
    { title: 'Easy', slug: 'easy', thumb: { path: Music9 }, project: 6},
    { title: 'Rosa', slug: 'rosa', thumb: { path: Music10 }, project: 6 },
    { title: 'Como Tu', slug: 'como-tu', thumb: { path: Music1 }, project: 6 },
    { title: 'Pensar em Mim', slug: 'pensar-em-mim', thumb: { path: Music2 }, project: 6 },
    /*{ title: 'Teste', slug: 'teste', thumb: { path: Music6 }, project: 6 }*/
];